import { TextField, Typography } from "@mui/material";
import * as React from "react";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { Base } from "ui/Scripts/source/framework/base";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol, } from "ui/Scripts/source/models/task/taskTypeCol";
import { FormFieldMargin } from "./TaskDynamicForm.styles";
import { DisabledInputClickEnabler } from "./DisabledInputClickEnabler";
import { getFormFieldTitle, getFormFieldTitleColor } from "./TaskDynamicFormFieldUtils";

export interface ITaskDynamicFormTimeSpanProp {
    isReadOnly: boolean;
    colIsReadOnly: boolean;
    showFieldName: boolean;
    showFieldNameColor: string;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormTimeSpan extends React.Component<ITaskDynamicFormTimeSpanProp, {}> {
    handleChange = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const value: string = target.value;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(value)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
        } else {
            newValue.valueStr = value;
            newValue.valueNbr = value.toTimeSpan();
        }
        props.onChange(newValue);
    };

    handleBlur = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const value: string = target.value;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(value)) {
            newValue.valueNbr = null;
        } else {
            newValue.valueNbr = value.toTimeSpan();
        }
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, newValue.valueStr, newValue.valueNbr);
        props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <FormField title={getFormFieldTitle(typeCol, props.showFieldName)} titleColor={getFormFieldTitleColor(props.showFieldName, props.showFieldNameColor)} required={typeCol.required && !props.isReadOnly} margin={FormFieldMargin}>
                {props.isReadOnly &&
                    <Typography>{dataCol?.valueStr}</Typography>
                }
                {!props.isReadOnly &&
                    <DisabledInputClickEnabler
                        input={<TextField
                            name={typeCol.field}
                            title={typeCol.title}
                            required={typeCol.required}
                            value={dataCol?.valueStr || ""}
                            disabled={props.colIsReadOnly}
                            inputProps={{ maxLength: 10 }}
                            placeholder={typeCol.placeholder ? typeCol.placeholder : null}
                            autoComplete="off"
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            size="small"
                            fullWidth
                        />}
                        disabled={props.colIsReadOnly}
                    />
                }
            </FormField>
        );
    }
}